<template>
  <div class="links-panel" :class="{ 'only-two': userType <= 0 }">
    <SidebarHeader
      :menuItems="[
        {
          icon: 'add',
          text: 'Add a new Link',
          show: userType,
          click: () => openLinkForm()
        },
        {
          icon: 'delete',
          text: `Remove All Links (${items.length})`,
          show: userType && items.length,
          click: () => confirmRemoveAllLinks()
        }
      ]"
    >
      <template #title>Content</template>
      <div class="links-panel__types">
        <div
          v-for="(tab, i) in sortTypes"
          :class="['link-tab', {current: i === sortBy}]"
          :key="i"
          @click="changeSort(i)"
        >
          {{ tab }}
        </div>
      </div>
    </SidebarHeader>

    <div class="links-list" v-if="items.length > 0">
      <link-container
        v-for="(link, index) in items"
        :key="link.id"
        :link="link"
        :index="index"
      />
    </div>
    <div class="links-list" v-else-if="isLoading">
      <!-- todo: for some reason these have a max height -->
      <!-- the CSS is a mess, so it's probably something do with that -->
      <Skeleton
        v-for="i in 3"
        :key="i"
        style="justify-self: center;"
        size="91% auto" margin="10px 0 0 0" rounded noverflow
      >
        <Skeleton size="100% 120px" gradient/>
        <div style="padding: 23px;">
          <Skeleton size="90% 20px" shimmer rounded-sm margin="0 0 15px 0"/>
          <Skeleton size="70% 15px" shimmer rounded-sm/>
        </div>
      </Skeleton>
    </div>
    <div v-else class="no-links">No links to display</div>
  </div>
</template>

<script>
import Skeleton from '@/components/global/loading/Skeleton.vue';
import LinkContainer from './LinkContainer.vue';
import SidebarHeader from '../SidebarHeader.vue';

import LinkForm from '@/components/modals/links/LinkForm.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LinksPanel',
  components: { LinkContainer, SidebarHeader, Skeleton },
  data: () => ({
    // the order is important
    sortTypes: ['Date', 'Trending', 'A-Z'],
  }),
  computed: {
    ...mapGetters('library', ['items', 'sortBy', 'isLoading']),
    ...mapGetters({userType: 'current_user/currentAreaPermissionNo'}),
  },
  methods: {
    ...mapActions('library', ['changeSort']),
    ...mapActions('popups/content', ['confirmRemoveAllLinks']),
    ...mapActions(['modal/open']),
    openLinkForm() {
      this['modal/open']([LinkForm]);
    }
  },
  beforeMount(){
    //init fetch
    this.changeSort(0);
  }
};
</script>

<style scoped lang="scss">
@import '~@/scss/components/sidebar/links_panel.scss';
</style>
